var Wallop = require('Wallop');

var ImageSliderWithTextContent = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ImageSliderWithTextContent.prototype.init = function(){

  var self = this;

  var slider = this.options.$el.find('.Wallop')[0]; // wallop takes a plain JS element, so use [0]
  this.wallop = new Wallop(slider);

  // slide timer
	self.slideTimer = window.setInterval(function() {
	  self.wallop.next();
	}, 5000);

  // previous and next buttons
  this.options.$el.find('.previous-slide').on('click', function() {

    self.wallop.previous();

    // reset slide timer
    clearInterval(self.slideTimer);
    self.slideTimer = window.setInterval(function() {
      self.wallop.next();
    }, 5000);

  });

  this.options.$el.find('.next-slide').on('click', function() {

    self.wallop.next();

    // reset slide timer
    clearInterval(self.slideTimer);
    self.slideTimer = window.setInterval(function() {
      self.wallop.next();
    }, 5000);

  });

  // swipe events
  this.options.$el.find('.Wallop').on('swiperight', function() {

    self.wallop.previous();

    // reset slide timer
    clearInterval(self.slideTimer);
    self.slideTimer = window.setInterval(function() {
      self.wallop.next();
    }, 5000);
    
  });

  this.options.$el.find('.Wallop').on('swipeleft', function() {
    
    self.wallop.next();

    // reset slide timer
    clearInterval(self.slideTimer);
    self.slideTimer = window.setInterval(function() {
      self.wallop.next();
    }, 5000);

  });

};

module.exports = ImageSliderWithTextContent;
